module.exports = "<router-view _v-46a1939e=\"\"></router-view>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-46a1939e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/component/user/user-page.vue
// module id = 371
// module chunks = 0